"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { list: [] };
    },
    onInput: function ({type}) {
        this.fetchBy(type);
    },
    fetchBy: async function (type) {
        try {
            const {error, message, extensions} = await MPSRequest(`/extension/list?type=${ type }`);
            if (error)
                throw new Error(message);
            this.state.list = extensions;
        } catch (error) {
            console.log(`Failed fetching <${ type }>: `, error);
            this.state.list = [];
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Marketplace/components/SortingList/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Favicon_template = require("../../../Favicon.marko"),
    Favicon_tag = marko_loadTag(Favicon_template),
    StarRating_template = require("../../../../../components/StarRating/index.marko"),
    StarRating_tag = marko_loadTag(StarRating_template),
    Bx_template = require("../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    marko_attrs0 = {
        "class": "px-3 py-2 theme-bg"
      },
    marko_attrs1 = {
        "class": "card bg-none shadow-none border-bottom rounded-0 m-0 py-50"
      },
    marko_attrs2 = {
        "class": "card-content"
      },
    marko_attrs3 = {
        "class": "col-lg-2 col-3 py-2 text-center cursor-pointer no-effect"
      },
    marko_attrs4 = {
        "class": "col-lg-8 col-6 px-1 py-50 cursor-pointer no-effect"
      },
    marko_attrs5 = {
        "class": "mb-2"
      },
    marko_attrs6 = {
        "class": "mb-2 w-100 font-small-2 text-ellipsis"
      },
    marko_attrs7 = {
        "class": "col-lg-2 col-3 px-1 py-50 text-right"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("section", marko_attrs0, "0", component);

  out.be("h5", null, "1", component);

  Locale_tag({
      text: input.type.toCapitalCase() + "s",
      class: "font-medium-1"
    }, out, __component, "2");

  out.ee();

  Row_tag(marko_mergeNestedTagsHelper({
      renderBody: function(out, $nestedTagRow$0) {
        var $for$0 = 0;

        marko_forOf(state.list, function(each, index) {
          const { type, name, description, nsi, version, favicon, configs } = each

          var $keyScope$0 = "[" + (($for$0++) + "]");

          Row_col_nested_tag({
              qs: "col-12",
              hs: "col-lg-6 col-6",
              fs: "col-lg-3 col-12",
              renderBody: function(out) {
                out.be("div", marko_attrs1, "@" + index, component);

                out.be("div", marko_attrs2, "5" + $keyScope$0, component);

                Row_tag({
                    class: "no-gutters",
                    renderBody: function(out) {
                      out.be("div", marko_attrs3, "7" + $keyScope$0, component, null, 0, {
                          onclick: __component.d("click", () => component.emit('open', each ), false)
                        });

                      Favicon_tag(marko_assign({
                          width: 44
                        }, each, {
                          class: "font-large-1"
                        }), out, __component, "8" + $keyScope$0);

                      out.ee();

                      out.be("div", marko_attrs4, "9" + $keyScope$0, component, null, 0, {
                          onclick: __component.d("click", () => component.emit('open', each ), false)
                        });

                      out.e("p", marko_attrs5, "10" + $keyScope$0, component, 1)
                        .t(name, component);

                      out.e("p", marko_attrs6, "11" + $keyScope$0, component, 1)
                        .t(description, component);

                      StarRating_tag({
                          score: 4.5,
                          size: "12",
                          color: "grey"
                        }, out, __component, "12" + $keyScope$0);

                      out.ee();

                      out.be("div", marko_attrs7, "13" + $keyScope$0, component);

                      if (window.Extensions.isInstalled((nsi + "~") + version)) {
                        Locale_tag({
                            text: "Installed",
                            class: "font-small-2 float-right text-success"
                          }, out, __component, "14" + $keyScope$0);

                        if ((!configs) || (!configs.default)) {
                          out.e("br", null, "15" + $keyScope$0, component, 0);

                          out.e("br", null, "16" + $keyScope$0, component, 0);

                          Bx_tag({
                              type: "export",
                              title: Locale("Uninstall"),
                              class: "font-medium-5 border rounded-circle p-50 cursor-pointer"
                            }, out, __component, "17" + $keyScope$0, [
                            [
                              "click",
                              () => component.emit('uninstall', nsi ),
                              false
                            ]
                          ]);
                        }
                      } else {
                        Bx_tag({
                            type: "import",
                            title: Locale("Install"),
                            class: "font-medium-5 border rounded-circle p-50 cursor-pointer"
                          }, out, __component, "18" + $keyScope$0, [
                          [
                            "click",
                            () => component.emit('install', each ),
                            false
                          ]
                        ]);
                      }

                      out.ee();
                    }
                  }, out, __component, "6" + $keyScope$0);

                out.ee();

                out.ee();
              }
            }, $nestedTagRow$0);
        });
      }
    }), out, __component, "3");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
